import { cn } from '@/lib/utils/cn';

interface PageShellProps {
  children: React.ReactNode;
  className?: string;
}

export function PageShell({ children, className }: PageShellProps) {
  return (
    <main className={cn('page-surface overflow-hidden', className)}>
      {children}
    </main>
  );
}

interface PageHeroProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHero({ eyebrow, title, description, actions, className }: PageHeroProps) {
  return (
    <section className={cn('relative pt-4 sm:pt-36', className)}>
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[520px] bg-brand-mesh opacity-80" />
      <div className="section-shell">
        <div className="mx-auto max-w-4xl text-center">
          {eyebrow && <div className="section-kicker">{eyebrow}</div>}
          <h1 className="mt-6 text-balance text-5xl font-semibold leading-[0.98] tracking-normal text-ink-950 sm:text-6xl lg:text-7xl">
            {title}
          </h1>
          {description && (
            <p className="body-copy mx-auto mt-6 max-w-2xl">
              {description}
            </p>
          )}
          {actions && <div className="mt-8 flex flex-wrap items-center justify-center gap-3">{actions}</div>}
        </div>
      </div>
    </section>
  );
}
